
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">探索虚拟人技术：打造个性化数字化形象</h2>
                    <div class="time">2023-06-19 10:00:10</div>
                    <div class="start">
                        随着数字化时代的到来，虚拟人技术正逐渐引起人们的关注和兴趣。深圳羽迹科技有限公司作为该领域的先驱者，正致力于探索虚拟人技术的潜力，并通过创新的解决方案，为用户打造个性化的数字化形象。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/204.png" alt="探索虚拟人技术：打造个性化数字化形象" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            虚拟人技术是一项基于人工智能和图形图像算法的创新技术，旨在通过数字化方式创造出高度逼真的虚拟人形象。羽迹科技凭借其卓越的技术实力和自主研发的算法，能够从单张或多张照片中快速生成高保真的3D数字人形象。这项技术的出现为用户提供了一个全新的方式来表达自己的个性和特点。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            在羽迹科技的数字人技术中，个性化是一个重要的关键词。通过虚拟人技术，用户可以根据自己的喜好和需求定制自己的数字化形象。无论是在虚拟试穿领域，还是在发型设计、医美仿真等领域，用户可以通过羽迹科技的解决方案，根据自己的实际情况进行个性化的定制和体验。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            在虚拟试穿领域，羽迹科技的数字人技术为用户提供了全新的购物体验。用户可以通过虚拟人形象在线上试穿不同款式和尺码的服装，实时感受不同服装的效果和搭配，避免了传统试穿的繁琐和限制。这种个性化的数字化形象帮助用户更好地选择适合自己的服装风格，提升了购物的便利性和满意度。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            发型设计领域也是虚拟人技术的重要应用之一。通过羽迹科技的数字人技术，用户可以在虚拟环境中尝试不同的发型和发色，以找到最适合自己的造型。这种个性化的数字化形象让用户更加自信和满意，同时也为美发行业提供了更准确和个性化的服务。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            医美仿真是虚拟人技术在医疗美容领域的又一重要应用。通过数字化的虚拟形象，医美专业人士可以对患者进行术前仿真和效果展示，从而提供更加精确和可靠的医疗美容方案。这种个性化的数字化形象不仅为医美行业带来了创新和进步，也为患者提供了更好的决策依据和安全保障。
                        </div>
                    </div>

                    <div class="end">
                        深圳羽迹科技有限公司正以其创新的虚拟人技术，推动着个性化数字化形象的发展。未来，随着技术的不断进步和应用场景的扩大，虚拟人技术将成为数字化时代的重要一环，为用户和企业带来更加丰富和个性化的体验。让我们拭目以待，期待羽迹科技在虚拟人技术领域继续创新，为我们打造更加个性化的数字化未来
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "虚拟形象与直播的元宇宙社交?-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "虚拟形象与直播的元宇宙社交?,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "二次元文化随着Z世代消费力量的崛起，也逐渐突破小众圈层走进品牌营销的大众视野",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo204.vue